import script from "./formulaTooltip.vue?vue&type=script&setup=true&lang=js"
export * from "./formulaTooltip.vue?vue&type=script&setup=true&lang=js"

import "./formulaTooltip.vue?vue&type=style&index=0&id=963f7ba0&lang=scss"

const __exports__ = script;

export default __exports__